import { URLS } from '@wix/da-url';
import { BackgroundType, BackgroundImageDisplayMode } from './types';
const CACHE_BUSTER = 4;
export const TEMPLATES = [
    {
        title: 'Empty Canvas',
        subtitle: 'Start from Scratch',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_1.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: '',
        moduleData: {
            color: '',
            gradient: 0,
            imageTint: 'rgba(28,28,61,0.19)',
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            backgroundType: BackgroundType.TEMPLATE_1
        }
    },
    {
        title: 'Dawn Grid',
        subtitle: 'Commission List',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_2.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_2.jpg?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_2,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0)'
        }
    },
    {
        title: 'Funky Fronds',
        subtitle: 'Introduction',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_3.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_3.jpg?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_3,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0.27)'
        }
    },
    {
        title: 'Floral Breeze',
        subtitle: 'Introduction',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_4.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_4.gif?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_4,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0)'
        }
    },
    {
        title: 'Marbleized',
        subtitle: 'Moodboard',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_5.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_5.jpg?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_5,
            color: '#F2F4E8',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(247,247,233,0)'
        }
    },
    {
        title: 'Pixel Perfect',
        subtitle: 'Commission List',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_6.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_6.png?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_6,
            color: '#F8F2F8',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            imageTint: 'rgba(255,255,255,0)',
            pattern: `${URLS.CDN}/misc/custombox/patterns/pink-diamonds.png?${CACHE_BUSTER}`
        }
    },
    {
        title: 'Stellar',
        subtitle: 'Introduction',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_7.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_7.png?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_7,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0)'
        }
    },
    {
        title: 'Pastel Whimsy',
        subtitle: 'Commission List',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_8.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_8.png?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_8,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(222,129,104,0.49)'
        }
    },
    {
        title: 'Twinkle',
        subtitle: 'Moodboard',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_9.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_9.gif?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_9,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            imageTint: 'rgba(6,7,13,0)'
        }
    },
    {
        title: 'Autumn Mist',
        subtitle: 'Literature',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_10.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_10.jpg?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_10,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(229,229,223,0.86)'
        }
    },
    {
        title: 'Gatsby Deco',
        subtitle: 'Introduction',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_11.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_11.png?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_11,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            imageTint: 'rgba(1,6,38,0)'
        }
    },
    {
        title: 'Arcade Invaders',
        subtitle: 'Introduction',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_12.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_12.gif?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_12,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.TILE,
            imageTint: 'rgba(6, 7, 13,0.14)'
        }
    },
    {
        title: 'Haunted Graveyard',
        subtitle: 'Moodboard',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_13.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_13.jpeg?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_13,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0)'
        }
    },
    {
        title: 'Spooky Pumpkin',
        subtitle: 'Introduction',
        previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_14.thumb.png?${CACHE_BUSTER}`,
        backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_14.jpeg?${CACHE_BUSTER}`,
        moduleData: {
            backgroundType: BackgroundType.TEMPLATE_14,
            color: '',
            gradient: 0,
            imageDisplayMode: BackgroundImageDisplayMode.COVER,
            imageTint: 'rgba(6,7,13,0)'
        }
    }
];
